<template>
  <div>
    <div class="tile mb-1">
      <div class="row" >
        <div class="col-md-2">
          <button @click="load" class="btn btn-primary mr-1 mb-1">
            <i class="fa fa-refresh mr-0"></i>
            {{ $t('getCall') }}
          </button>
        </div>
        <div class="col-md">
          <div v-if="msg" class="alert alert-success text-center">{{msg}}</div>
        </div>
      </div>
    </div>

    <div class="row" v-if="adminCall && call" >
      <div class="col-md-4">
        <fieldset class="scheduler-border tile">
          <legend class="scheduler-border">
            {{$t("callInfo")}}
          </legend>
          <p>
            <font-awesome-icon :class="iconClass(call)" size="2x" :icon="icon(call)" />
            {{ $t(call.direction) }} | <span>{{ call.hangupCause }}</span>
          </p>
          <p>
            <b>ID:&nbsp;</b><span>{{ call._id.toString() }}</span>
          </p>
          <p>
            <b>{{ $t('startTime') }}:&nbsp;</b><span>{{ call.startTime | moment('HH:mm:ss DD/MM/YYYY') }}</span>
          </p>
          <p v-if="call.answerTime">
            <b>{{ $t('answerTime') }}:&nbsp;</b><span>{{ call.answerTime | moment('HH:mm:ss DD/MM/YYYY') }}</span>
          </p>
          <p v-if="call.endTime">
            <b>{{ $t('endTime') }}:&nbsp;</b><span>{{ call.endTime | moment('HH:mm:ss DD/MM/YYYY') }}</span>
          </p>
          <p>
            <b>{{ $t('duration') }}:&nbsp;</b><span>{{ call.duration | callDuration }}</span>
          </p>
          <p>
            <b>{{ $t('billDuration') }}:&nbsp;</b><span>{{ call.billDuration | callDuration }}</span>
          </p>
            <p v-if="call.audioQuality">
              <b>{{ $t('audioQuality') }}:&nbsp;</b><span>{{ call.audioQuality }}</span>
            </p>
            <p v-if="call.direction === 'inbound' && (call.hangupCause !== 'NORMAL_CLEARING' || !call.billDuration)">
                <span><b class="text-danger">{{ $t('missCall') }}</b></span>
            </p>
          <app-audio v-if="call.recordingDownloaded" :id="call._id" :duration="call.duration" />
        </fieldset>
      </div>
      <div class="col-md">
        <fieldset class="scheduler-border tile">
          <legend class="scheduler-border">
            {{$t("translateCall")}}
          </legend>
          <div class="alert alert-warning" :class="[['leftOne', 'leftTwo'].includes(type) ? 'alert-warning' : 'alert-info']">{{$t(type)}}</div>

          <span v-if="formModel.change" class="mr-1 badge badge-warning mr-1">{{$t("adminChange")}}</span>
          <span v-if="formModel.cancelTime" class="mr-1 badge badge-danger">{{$t("canceled")}}</span>
          <span v-else-if="formModel.confirmTime" class="mr-1 badge badge-success">{{$t("confirmed")}}</span>
          <span v-else-if="formModel.submitTime" class="mr-1 badge badge-primary">{{$t("submit")}}</span>
          <span v-if="formModel.note" class="text-gray-999 small" >{{formModel.note}}</span>

          <div v-if="formModel.confirmTime">
            <b>{{$t('confirmTime')}}: </b> {{formModel.confirmTime | moment('DD/MM/YYYY HH:mm:ss')}}
          </div>
          <div v-if="formModel.cancelTime" >
            <b>{{$t('cancelTime')}}: </b> {{formModel.cancelTime | moment('DD/MM/YYYY HH:mm:ss')}}
          </div>

          <form-array :label="$t('content')" class="mt-2" :model="formModel" attribute="transcripts" :errors="formErrors" @change="changeTranscript" />
          <div class="text-center">
            <b-button variant="primary" class="mr-2" :disabled="!formModel.transcripts || !formModel.transcripts.length" @click="save(false)">
              <i class="fa fa-save mr-0"></i>
              {{ $t('save') }}
            </b-button>

            <b-button variant="success" :disabled="!formModel.transcripts || !formModel.transcripts.length" @click="save(true)">
              <i class="fa fa-arrow-right"></i>
              {{ $t('saveAndNext') }}
            </b-button>
          </div>
        </fieldset>
      </div>
    </div>
    <div v-else-if="type" class="alert alert-warning mt-3 text-center" >Không có cuộc gọi nào trong kho cần biên dịch</div>
  </div>
</template>
<script>

import AppAudio from "@/components/AppAudio";
import FormArray from "./FormArray";

export default {
  components: {AppAudio, FormArray},
  data: function () {
    return {
      service: '/admin-call',
      formErrors: [],
      formModel: {
        user: this.$store.state.user._id,
        transcripts: []
      },
      call: null,
      adminCall: null,
      type: null,
      key: `admin-call-${this.$store.state.user._id}}`,
      msg: null
    }
  },
  i18n: {
    messages: {
      en: {
        getCall: 'Lấy cuộc gọi',
        callInfo: "Thông tin cuộc gọi",
        translateCall: 'Biên dịch',
        number: 'Số',
        ext: 'Nhánh',
        contact: 'Khách',
        ticket: 'Ticket',
        user: 'Nhân viên',
        incoming: 'Gọi vào',
        outgoing: 'Gọi ra',
        local: 'Gọi nội bộ',
        from: 'Gọi từ',
        to: 'Gọi đến',
        callDetail: 'Chi tiết cuộc gọi',
        direction: 'Hướng gọi',
        duration: 'Tổng thời gian',
        billDuration: 'Đàm thoại',
        startTime: 'Bắt đầu',
        answerTime: 'Trả lời',
        endTime: 'Kết thúc',
        hangupCause: 'Kết quả',
        NORMAL_CLEARING: 'Thành công',
        USER_BUSY: 'Máy bận',
        ORIGINATOR_CANCEL: 'Người gọi dừng',
        NO_USER_RESPONSE: 'Không nghe máy',
        listenRecording: 'Nghe ghi âm',
        createContact: 'Tạo KH mới',
        createTicket: 'Tạo ticket mới',
        addToTicket: 'Thêm vào ticket',
        content: 'Nội dung',
        fail: 'Kết nối thất bại',
        noTranscript: 'Không ghi nhận được nội dung',
        toNumber: 'Gọi ra đến số',
        fromNumber: 'Gọi ra từ số',
        allCallDirection: 'Hướng gọi: Tất cả',
        allCallStatus: 'Trạng thái: Tất cả',
        audioQuality: 'Chất lượng gọi',
        na: 'Không có thông tin',
        missCall: 'Gọi nhỡ',
        outboundSuccess: 'Gọi ra thành công',
        outboundFailed: 'Gọi ra thất bại',
        'leftOne': "Chỉ dịch tiếng của nhân viên",
        'leftTwo': "Chỉ dịch tiếng của nhân viên",
        'rightOne': "Chỉ dịch tiếng của khách",
        'rightTwo': "Chỉ dịch tiếng của khách",
        saveAndNext: "Lưu và lấy cuộc gọi khác",
        adminChange: "Admin chỉnh nội dung",
        submit: "Chờ duyệt",
        canceled: "Từ chối",
        confirmed: "Đã duyệt",
        submitTime: "Dịch lúc",
        confirmTime: "Duyệt lúc",
        cancelTime: "Từ chối lúc",
        confirmBy: "Nhân viên duyệt",
        cancelBy: "Nhân viên từ chối",
      },
      vi: {
        getCall: 'Lấy cuộc gọi',
        callInfo: "Thông tin cuộc gọi",
        translateCall: 'Biên dịch',
        number: 'Số',
        ext: 'Nhánh',
        contact: 'Khách',
        ticket: 'Ticket',
        user: 'Nhân viên',
        incoming: 'Gọi vào',
        outgoing: 'Gọi ra',
        local: 'Gọi nội bộ',
        from: 'Gọi từ',
        to: 'Gọi đến',
        callDetail: 'Chi tiết cuộc gọi',
        direction: 'Hướng gọi',
        duration: 'Tổng thời gian',
        billDuration: 'Đàm thoại',
        startTime: 'Bắt đầu',
        answerTime: 'Trả lời',
        endTime: 'Kết thúc',
        hangupCause: 'Kết quả',
        NORMAL_CLEARING: 'Thành công',
        USER_BUSY: 'Máy bận',
        ORIGINATOR_CANCEL: 'Người gọi dừng',
        NO_USER_RESPONSE: 'Không nghe máy',
        listenRecording: 'Nghe ghi âm',
        createContact: 'Tạo KH mới',
        createTicket: 'Tạo ticket mới',
        addToTicket: 'Thêm vào ticket',
        content: 'Nội dung',
        fail: 'Kết nối thất bại',
        noTranscript: 'Không ghi nhận được nội dung',
        toNumber: 'Gọi ra đến số',
        fromNumber: 'Gọi ra từ số',
        allCallDirection: 'Hướng gọi: Tất cả',
        allCallStatus: 'Trạng thái: Tất cả',
        audioQuality: 'Chất lượng gọi',
        na: 'Không có thông tin',
        missCall: 'Gọi nhỡ',
        outboundSuccess: 'Gọi ra thành công',
        outboundFailed: 'Gọi ra thất bại',
        leftOne: "Chỉ dịch tiếng của nhân viên",
        leftTwo: "Chỉ dịch tiếng của nhân viên",
        rightOne: "Chỉ dịch tiếng của khách",
        rightTwo: "Chỉ dịch tiếng của khách",
        saveAndNext: "Lưu và lấy cuộc gọi khác",
        adminChange: "Admin chỉnh nội dung",
        submit: "Chờ duyệt",
        canceled: "Từ chối",
        confirmed: "Đã duyệt",
        submitTime: "Dịch lúc",
        confirmTime: "Duyệt lúc",
        cancelTime: "Từ chối lúc",
        confirmBy: "Nhân viên duyệt",
        cancelBy: "Nhân viên từ chối",
      }
    }
  },
  methods: {
    changeTranscript(val) {
      let data = localStorage.getItem(this.key);
      if(data) {
        data = JSON.parse(data);
      } else {
        data = {}
      }
      if(val) {
        data[this.call._id.toString()] = val;
      } else {
        delete data[this.call._id.toString()];
      }
      localStorage.setItem(this.key, JSON.stringify(data));
    },
    icon(item) {
      if (item.direction === 'inbound') {
        return 'sign-in-alt';
      }
      if (item.direction === 'outbound') {
        return 'sign-out-alt';
      }
      if (item.direction === 'local') {
        return 'sync-alt';
      }
    },
    iconClass(item) {
      if (item.hangupCause === 'NORMAL_CLEARING') {
        return 'text-success';
      } else {
        return 'text-danger';
      }
    },
    load() {
      let loader = this.$loading.show();
      this.type = null;
      this.msg = null;
      this.$service.get(this.service + '/translate').then(response => {
        this.call = {};
        this.adminCall = {};
        this.adminCall = response.data.model;
        this.call = this.adminCall ? this.adminCall.call : null;
        this.type = response.data.type;

        if(this.adminCall && this.adminCall[this.type]) {
          this.formModel =  this.adminCall[this.type];
        }


        if(!this.formModel.transcripts || !this.formModel.transcripts.length) {
          let data = localStorage.getItem(this.key);
          if(data) {
            data = JSON.parse(data);
          }
          if(this.call && data && data[this.call._id.toString()]) {
            this.formModel.transcripts = data[this.call._id.toString()];
          }
        }

      }).finally(() => {
        loader.hide();
      });
    },
    save(next) {
      let loader = this.$loading.show();
      this.msg = null;
      this.formModel.type = this.type;
      this.$service({url: `${this.service}/${this.adminCall._id}`, method: 'put', data: this.formModel}).then(response => {
        this.changeTranscript([]);
        this.formModel.transcripts = [];
        this.call = null;
        this.adminCall = null;
        this.type = null;

        if (response.data) {
          if(next) {
            setTimeout(() => {
              this.load();
              this.msg = null;
            }, 1000);
          }
          this.msg = this.$t('updated');
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t(this.formModel.id ? 'updateFailed' : 'createFailed'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
          this.showForm = false;
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        loader.hide();
      });
    }
  }
}
</script>